import React from 'react'
import { Router } from 'react-static'
import { injectGlobal } from 'styled-components'
import { hot } from 'react-hot-loader'

import Routes from 'react-static-routes'

injectGlobal`
  body {
    font-family: 'Source Code Pro', monospace;
    font-weight: 300;
    font-size: 16px;
    margin: 0;
    padding: 0;
  }

  *, *:after, *:before {
    box-sizing: border-box;
    font: inherit;
    color: inherit;
    margin: 0;
    padding: 0;
    border: none;
    outline: none;
  }

  a {
    text-decoration: none;
    color: #108db8;
    font-weight: bold;
  }
`

const App = () => (
  <Router>
    <Routes />
  </Router>
)

export default hot(module)(App)



// WEBPACK FOOTER //
// /Users/apercu/git/ashlar/statics/domains/src/App.js